import React, { useState, useEffect } from "react";
import { FaCircleArrowRight } from "react-icons/fa6";
import { FaCircleArrowLeft } from "react-icons/fa6";

const Slider = ({ images }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images]);

  const nextslide = () =>{
    setIndex((prevIndex) => (prevIndex + 1) % images.length);
  }

  const prevSlide = () => {
    setIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <>
      <div class="relative overflow-hidden rounded-md">
        <div class="absolute right-5 top-5 z-10 rounded-full bg-darkgrey px-2 text-center text-sm text-lightgrey">
          <span>
            {index+1}/{images.length}
          </span>
        </div>

        <button class="absolute right-1/2 bottom-0 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full " onClick={prevSlide}>
          <i class="text-2xl bg-lightgrey rounded-full ">
            <FaCircleArrowLeft />
          </i>
        </button>

        <button class="absolute left-1/2 bottom-0 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full " onClick={nextslide}>
          <i class="text-2xl shadow-md bg-lightgrey rounded-full">
            <FaCircleArrowRight />
          </i>
        </button>

        <div class="flex justify-center item-center">
          <div class="w-[100%]">
            <img src={images[index]} alt="image" class="rounded-sm object-cover" />
          </div>
        </div>
        
      </div>
    </>
  );
};

export default Slider;
